export const getPhonePattern = (phone: string): string => {
  const phoneClean = phone
    .replace("+1", "")
    .replaceAll(" ", "")
    .replaceAll("-", "");

  return `${phoneClean.slice(0, 3)}-${phoneClean.slice(3, 6)}-${phoneClean.slice(6, phoneClean.length)}`;
};
